import * as React from "react";
const IconTaskFillEmpty = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.6665 9H17.6665M7.6665 13H17.6665M7.6665 17H12.6665M16.6665 2V5M8.6665 2V5M7.6665 22H17.6665C19.8756 22 21.6665 20.2091 21.6665 18V7.5C21.6665 5.29086 19.8756 3.5 17.6665 3.5H7.6665C5.45737 3.5 3.6665 5.29086 3.6665 7.5V18C3.6665 20.2091 5.45736 22 7.6665 22Z"
      stroke={props.color || "#FDFEFE"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconTaskFillEmpty;
